/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Saving_RecordingInputs */



/**
* | output |
* | --- |
* | "Saving Recording" |
*
* @param {Audio_Recorder_Saving_RecordingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_saving_recording = /** @type {((inputs?: Audio_Recorder_Saving_RecordingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Saving_RecordingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement en cours")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufnahme speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio della registrazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранение записи")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardando grabación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存录音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("録音の保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग सहेजी जा रही है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gravação de salvamento")
	return /** @type {LocalizedString} */ ("Saving Recording")
});